
  import { defineComponent, ref, computed } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useI18n } from 'vue-i18n/index';
  import {
    pct,
    textColor,
    arrowSrc,
    arrow,
  } from '@/core/helpers/dashboard-utils';
  import CustomDatePicker from '@/components/search/CustomDatePicker.vue';

  export default defineComponent({
    name: 'subscriptions-report-widget',
    props: {
      widgetClasses: String,
    },
    components: {
      CustomDatePicker,
    },
    async setup() {
      const { t, te } = useI18n();
      const loading = ref(false);
      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };
      const selectedPeriod = ref('last-7-days');
      const customDateFrom = ref('');
      const customDateTo = ref('');
      const showDatePicker = ref(false);
      const enableTrend = ref(true);

      interface AdsSummaryItem {
        title: string;
        desc: string;
        count: string;
        trend: string;
      }
      const arrayOfData = ref<AdsSummaryItem[]>([]);
      const regularAds = ref<{ total?: number; percentage?: number }>({});
      const specialAds = ref<{ total?: number; percentage?: number }>({});

      const store = useStore();
      await store.dispatch(Actions.GET_ADS_SUMMERY_DASHBOARD);
      const data = computed(() => store.getters.adsSummeryDashboard);

      regularAds.value.total = data.value.data.totalRegularAds;
      regularAds.value.percentage = data.value.data.regularAdsPercentage;
      specialAds.value.total = data.value.data.totalSpecialAds;
      specialAds.value.percentage = data.value.data.specialAdsPercentage;
      arrayOfData.value = [
        {
          title: 'Ads Views',
          desc: 'No. of Views: ',
          count: data.value.data.adsViews,
          trend: '',
        },
        {
          title: 'Ads Calls',
          desc: 'No. of Calls: ',
          count: data.value.data.adsCalls,
          trend: '',
        },
        {
          title: 'Ads WhatsApp Text',
          desc: 'No. of WhatsApp Text: ',
          count: data.value.data.adsWhatsappText,
          trend: '',
        },
      ];

      const showCustomDatePicker = () => {
        showDatePicker.value = true;
        selectedPeriod.value = 'custom';
      };

      const applyCustomDates = async () => {
        if (!customDateFrom.value || !customDateTo.value) {
          alert('Please select both dates');
          return;
        }
        showDatePicker.value = false;
        await selectPeriod('custom');
      };

      const selectPeriod = async (period: string) => {
        // selectedPeriod.value = period;
        loading.value = true;
        selectedPeriod.value = period;
        try {
          const obj = {
            dateRange: period,
            showTrend: false,
            dateFrom: '',
            dateTo: '',
          };

          if (
            period === 'custom' &&
            customDateFrom.value &&
            customDateTo.value
          ) {
            obj.dateFrom = customDateFrom.value;
            obj.dateTo = customDateTo.value;
          }
          await store.dispatch(Actions.GET_ADS_SUMMERY_DASHBOARD, obj);
          const payload = store.getters.adsSummeryDashboard;
          regularAds.value.total = payload.data.totalRegularAds;
          regularAds.value.percentage = payload.data.regularAdsPercentage;
          specialAds.value.total = payload.data.totalSpecialAds;
          specialAds.value.percentage = payload.data.specialAdsPercentage;
          arrayOfData.value = [
            {
              title: 'Ads Views',
              desc: 'No. of Views: ',
              count: payload.data.adsViews,
              trend: '',
            },
            {
              title: 'Ads Calls',
              desc: 'No. of Calls: ',
              count: payload.data.adsCalls,
              trend: '',
            },
            {
              title: 'Ads WhatsApp Text',
              desc: 'No. of WhatsApp Text: ',
              count: payload.data.adsWhatsappText,
              trend: '',
            },
          ];
        } finally {
          loading.value = false;
        }
      };

      return {
        textColor,
        arrowSrc,
        regularAds,
        specialAds,
        arrayOfData,
        data,
        loading,
        selectedPeriod,
        selectPeriod,
        arrow,
        pct,
        translate,
        showDatePicker,
        customDateFrom,
        customDateTo,
        showCustomDatePicker,
        applyCustomDates,
        enableTrend,
      };
    },
  });
